<template>
     <div class="art_content"  v-wechat-title='$route.meta.title'>
        <div v-html="mdcontent" class="markdown-body"></div>
     </div>
 </template>
  <script>
    import marked from 'marked'
    import 'mavon-editor/dist/markdown/github-markdown.min.css'
    import 'mavon-editor/dist/katex/katex.min.css'
    export default {
        name: 'test',
        data () {
          return {
            // src:'./static/html/test.html',
            mdcontent:''
          }
        },
        methods:{
          getarticle(){
            this.$http({
                method: 'get',
                url: '/article',
                params: {
                  id: this.$route.query.id
                },
            })
            .then((res) => {
              if (res['data']['Code'] === 0) {
                   this.mdcontent = marked(res['data']["Data"]['MarkdownContent'])
              } else {
                this.$toast(res['data']["Message"])
              }
            })
          }
        },
        beforeCreate () {
          document.title =this.$route.query.title
        },
        mounted(){
          this.getarticle()
        }
    }
</script>
<style lang='scss'>
  .art_content{
    display: flex;
    flex-direction: column;
    height: 100%;
    text-align: left;
    padding: 1.625rem;
    .markdown-body{
      font-size:0.875rem;
    }
    ol{
      list-style: unset;
      list-style-type: decimal;
    }
    h1,h2,h3,h4,h5,h6{
      margin-top: 1rem;
      margin-bottom: 1rem;
    }
    .markdown-body blockquote, .markdown-body dl, .markdown-body ol, .markdown-body p, .markdown-body pre, .markdown-body table, .markdown-body ul{
      margin-bottom: 0.75rem;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/article.vue